export const showElements = (items, count) => {
  items.forEach((item, i) => {
    if (!count || i < count) {
      item.style.display = "table-row";
    } else {
      item.style.display = "none";
    }
  });
};

export const showMore = (initialCount = 8, step = 8) => {
  const wrappers = document.querySelectorAll(".showMoreWrapper");

  if (!wrappers) return;

  wrappers.forEach((showMoreBlock) => {
    const items = showMoreBlock.querySelectorAll(".showMoreItem");
    const btn = showMoreBlock.querySelector(".showMoreBtn");

    if (!items) return;
    const itemsLenth = items.length;

    //отображаем количество элементов по умолчанию
    showElements(items, initialCount);

    //если элементов мало, то скрываем кнопку
    if (itemsLenth <= initialCount && btn) {
      btn.style.display = "none";
    }

    if (!btn) return;

    let showedCount = initialCount;

    //обработка раскрытия элементов
    btn.addEventListener("click", () => {
      if (showedCount === itemsLenth) {
        const elementPosition =
          showMoreBlock.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
          top: elementPosition - 230,
          behavior: "smooth", // плавная прокрутка
        });

        showedCount = initialCount;
        btn.innerHTML = "Показать еще";
      } else if (showedCount + step >= itemsLenth) {
        showedCount = itemsLenth;
        btn.innerHTML = "Скрыть";
      } else {
        showedCount += step;
      }

      showElements(items, showedCount);
    });
  });
};

export const initShowMore = () => {
  showMore(10, 5);
};
